// =============================================
// Pedidos — Listagem e Modal de Detalhe
// =============================================
(function () {
  "use strict";

  var $lista = $("#pedidos-lista");
  if ($lista.length === 0) return;

  var apiUrl = $lista.data("api");

  var STATUS_LABELS = {
    novo:      "Novo",
    pendente:  "Pendente",
    concluido: "Concluído",
    cancelado: "Cancelado",
  };

  // =============================================
  // LISTAGEM
  // =============================================
  function init() {
    renderLoading($lista);
    $.ajax({
      url: apiUrl,
      type: "GET",
      data: { acao: "lista" },
      dataType: "json",
    }).done(function (resp) {
      if (resp.status === "ok") {
        renderLista(resp.pedidos);
      } else {
        renderErro($lista);
      }
    }).fail(function () {
      renderErro($lista);
    });
  }

  function renderLista(pedidos) {
    if (!pedidos || pedidos.length === 0) {
      $lista.html(
        '<div class="pedidos-empty">' +
          '<i class="las la-box-open"></i>' +
          '<p>Nenhum pedido encontrado.</p>' +
          '<a href="' + ($lista.data("url") || "") + 'minha-conta/produtos" class="btn btn-primario btn-sm">Fazer meu primeiro pedido</a>' +
        '</div>'
      );
      return;
    }

    var html =
      '<table class="pt">' +
        '<thead class="pt-head">' +
          '<tr>' +
            '<th class="pt-th">Pedido</th>' +
            '<th class="pt-th">Data</th>' +
            '<th class="pt-th">Itens</th>' +
            '<th class="pt-th">Total</th>' +
            '<th class="pt-th">Status</th>' +
            '<th class="pt-th"></th>' +
          '</tr>' +
        '</thead>' +
        '<tbody>';

    for (var i = 0; i < pedidos.length; i++) {
      var p        = pedidos[i];
      var label    = STATUS_LABELS[p.status] || p.status;
      var prodStr  = p.total_produtos + " " + (p.total_produtos === 1 ? "produto" : "produtos");
      var integStr = p.total_integrantes + " " + (p.total_integrantes === 1 ? "integrante" : "integrantes");

      html +=
        '<tr class="pt-row status-' + p.status + '">' +
          '<td class="pt-td pt-td-id"><strong>#' + p.id + '</strong></td>' +
          '<td class="pt-td pt-td-data">' + p.data_hora + '</td>' +
          '<td class="pt-td pt-td-itens">' + prodStr + ' · ' + integStr + '</td>' +
          '<td class="pt-td pt-td-valor"><span class="pt-valor">' + p.valor_fmt + '</span></td>' +
          '<td class="pt-td pt-td-status"><span class="conta-status ' + p.status + '">' + label + '</span></td>' +
          '<td class="pt-td pt-td-btn" data-valor="' + p.valor_fmt + '">' +
            '<button type="button" class="btn btn-pedido-detalhe" data-id="' + p.id + '">' +
              '<i class="las la-eye"></i> Detalhes' +
            '</button>' +
          '</td>' +
        '</tr>';
    }

    html += '</tbody></table>';
    $lista.html(html);
  }

  // =============================================
  // MODAL DE DETALHE
  // =============================================
  $(document).on("click", ".btn-pedido-detalhe", function () {
    var pedidoId = $(this).data("id");
    abrirDetalhe(pedidoId);
  });

  function abrirDetalhe(pedidoId) {
    // Reset header
    $("#modal-pedido-num").text("");

    renderLoading($("#modal-pedido-body"));
    openModal("modal-pedido");

    $.ajax({
      url: apiUrl,
      type: "GET",
      data: { acao: "detalhe", id: pedidoId },
      dataType: "json",
    }).done(function (resp) {
      if (resp.status === "ok") {
        renderModalDetalhe(resp.pedido);
      } else {
        renderErro($("#modal-pedido-body"));
      }
    }).fail(function () {
      renderErro($("#modal-pedido-body"));
    });
  }

  function renderModalDetalhe(pedido) {
    var statusLabel = STATUS_LABELS[pedido.status] || pedido.status;

    // Atualizar número no header
    $("#modal-pedido-num").text(pedido.id);

    var html = "";

    // ===== RESUMO (status, data, total) =====
    html +=
      '<div class="pedido-modal-summary">' +
        '<span class="conta-status ' + pedido.status + '">' + statusLabel + '</span>' +
        '<span class="pedido-modal-data">' + pedido.data_hora + '</span>' +
        '<span class="pedido-modal-total-val">' + pedido.valor_fmt + '</span>' +
      '</div>';

    // ===== PRODUTOS =====
    if (pedido.produtos && pedido.produtos.length > 0) {
      html += '<div class="pedido-modal-section">';
      html += '<div class="pedido-modal-section-title">Produtos <span class="pedido-modal-section-count">(' + pedido.produtos.length + ')</span></div>';
      html += '<div class="pedido-produtos-grid">';

      for (var i = 0; i < pedido.produtos.length; i++) {
        var prod = pedido.produtos[i];

        html += '<div class="pedido-produto-card">';

        // Preview: base64 personalizado ou foto original
        var imgSrc = prod.preview_base64 || prod.foto_url;
        if (imgSrc) {
          html += '<div class="pedido-produto-preview"><img src="' + imgSrc + '" alt="' + escapeHtml(prod.titulo) + '"></div>';
        }

        html += '<div class="pedido-produto-info">';
        html += '<div class="pedido-produto-nome">' + escapeHtml(prod.titulo) + '</div>';
        html += '<div class="pedido-produto-valor">' + prod.valor_fmt + ' <small>/ unid.</small></div>';

        // Tags de personalização (dinâmicas)
        var tags = [];
        if (prod.personalizacoes && prod.personalizacoes.length > 0) {
          for (var pi2 = 0; pi2 < prod.personalizacoes.length; pi2++) {
            var pers = prod.personalizacoes[pi2];
            var tagText = escapeHtml(pers.titulo);
            if (pers.cor) {
              tagText += ' <small>(' + escapeHtml(pers.cor) + ')</small>';
            }
            if (pers.valor > 0) {
              tagText += ' <small>+R$ ' + pers.valor.toFixed(2).replace('.', ',') + (pers.tipo === 'numero' ? '/car.' : '') + '</small>';
            }
            tags.push(tagText);
          }
        }

        if (tags.length > 0) {
          html += '<div class="pedido-pers-tags">';
          for (var t = 0; t < tags.length; t++) {
            html += '<span class="pedido-pers-tag">' + tags[t] + '</span>';
          }
          html += '</div>';
        }

        html += '</div>'; // pedido-produto-info
        html += '</div>'; // pedido-produto-card
      }

      html += '</div></div>'; // grid + section
    }

    // ===== INTEGRANTES =====
    if (pedido.jogadores && pedido.jogadores.length > 0) {
      // Determinar colunas de variação na ordem dos produtos
      var varCols    = [];
      var varColKeys = {};
      for (var pi = 0; pi < pedido.produtos.length; pi++) {
        var pSlug = pedido.produtos[pi].categoria_slug;
        if (varColKeys[pSlug]) continue;
        // Verificar se algum jogador tem variação para este slug
        for (var ji = 0; ji < pedido.jogadores.length; ji++) {
          for (var vi = 0; vi < pedido.jogadores[ji].variacoes.length; vi++) {
            if (pedido.jogadores[ji].variacoes[vi].categoria_slug === pSlug) {
              varCols.push({ slug: pSlug, titulo: pedido.jogadores[ji].variacoes[vi].categoria_titulo || pSlug });
              varColKeys[pSlug] = true;
              break;
            }
          }
          if (varColKeys[pSlug]) break;
        }
      }

      // Verificar se há nome ou número em qualquer jogador
      var hasNome   = false;
      var hasNumero = false;
      for (var jj = 0; jj < pedido.jogadores.length; jj++) {
        if (pedido.jogadores[jj].nome)   hasNome   = true;
        if (pedido.jogadores[jj].numero) hasNumero = true;
      }

      var qtdTotal = 0;
      for (var jk = 0; jk < pedido.jogadores.length; jk++) {
        qtdTotal += pedido.jogadores[jk].quantidade;
      }

      html += '<div class="pedido-modal-section">';
      html += '<div class="pedido-modal-section-title">Integrantes <span class="pedido-modal-section-count">(' + pedido.jogadores.length + ' registros · ' + qtdTotal + ' unid.)</span></div>';
      html += '<div class="pedido-integrantes-wrap">';
      html += '<table class="pedido-integrantes-table"><thead><tr>';
      html += '<th>Qtd</th>';
      if (hasNome)   html += '<th>Nome</th>';
      if (hasNumero) html += '<th>Nº</th>';
      for (var ci = 0; ci < varCols.length; ci++) {
        html += '<th>' + escapeHtml(varCols[ci].titulo) + '</th>';
      }
      html += '</tr></thead><tbody>';

      for (var jl = 0; jl < pedido.jogadores.length; jl++) {
        var jog = pedido.jogadores[jl];

        // Mapa slug → titulo variação
        var varMap = {};
        for (var vm = 0; vm < jog.variacoes.length; vm++) {
          varMap[jog.variacoes[vm].categoria_slug] = jog.variacoes[vm].variacao_titulo;
        }

        html += '<tr>';
        html += '<td>' + jog.quantidade + '</td>';
        if (hasNome)   html += '<td>' + escapeHtml(jog.nome   || "—") + '</td>';
        if (hasNumero) html += '<td>' + escapeHtml(jog.numero || "—") + '</td>';
        for (var cv = 0; cv < varCols.length; cv++) {
          html += '<td>' + escapeHtml(varMap[varCols[cv].slug] || "—") + '</td>';
        }
        html += '</tr>';
      }

      html += '</tbody></table></div>'; // table + wrap

      html += '<div class="pedido-total-row">';
      html += '<strong>' + qtdTotal + '</strong> unidades · Total: <strong>' + pedido.valor_fmt + '</strong>';
      html += '</div>';

      html += '</div>'; // section
    }

    // ===== DETALHAMENTO DE PREÇO (expansível) =====
    if (pedido.produtos && pedido.produtos.length > 0) {
      var qtdTotalPreco = 0;
      if (pedido.jogadores) {
        for (var jq = 0; jq < pedido.jogadores.length; jq++) {
          qtdTotalPreco += pedido.jogadores[jq].quantidade || 1;
        }
      }
      if (qtdTotalPreco === 0) qtdTotalPreco = 1;

      html += '<div class="pedido-modal-section">';
      html += '<div class="pedido-modal-section-title pedido-preco-toggle" style="cursor:pointer;">';
      html += '<span>Detalhamento de preço</span> <i class="las la-angle-down" style="font-size:16px; transition:0.3s;"></i>';
      html += '</div>';
      html += '<div class="pedido-preco-detail" style="display:none;">';

      var grandTotal = 0;

      for (var dp = 0; dp < pedido.produtos.length; dp++) {
        var dprod = pedido.produtos[dp];
        var baseTotal = dprod.valor_unitario * qtdTotalPreco;
        grandTotal += baseTotal;

        html += '<div class="pedido-preco-line">';
        html += '<span>' + escapeHtml(dprod.titulo) + '</span>';
        html += '<span>R$ ' + dprod.valor_unitario.toFixed(2).replace(".", ",") + ' x' + qtdTotalPreco + ' = <strong>R$ ' + baseTotal.toFixed(2).replace(".", ",") + '</strong></span>';
        html += '</div>';

        if (dprod.personalizacoes) {
          for (var dpi = 0; dpi < dprod.personalizacoes.length; dpi++) {
            var dpers = dprod.personalizacoes[dpi];
            if (dpers.valor <= 0) continue;

            var persTotal = 0;
            if (dpers.tipo === "numero" && pedido.jogadores) {
              for (var dnj = 0; dnj < pedido.jogadores.length; dnj++) {
                var dnLen = (pedido.jogadores[dnj].numero || "").length;
                var dnQtd = pedido.jogadores[dnj].quantidade || 1;
                persTotal += dpers.valor * dnLen * dnQtd;
              }
            } else {
              persTotal = dpers.valor * qtdTotalPreco;
            }
            grandTotal += persTotal;

            html += '<div class="pedido-preco-line pedido-preco-addon">';
            html += '<span>+ ' + escapeHtml(dpers.titulo);
            if (dpers.cor) html += ' (' + escapeHtml(dpers.cor) + ')';
            html += '</span>';
            html += '<span><strong>R$ ' + persTotal.toFixed(2).replace(".", ",") + '</strong></span>';
            html += '</div>';
          }
        }
      }

      html += '<div class="pedido-preco-total">';
      html += '<span>Total</span>';
      html += '<span><strong>' + pedido.valor_fmt + '</strong></span>';
      html += '</div>';

      html += '</div></div>'; // detail + section
    }

    $("#modal-pedido-body").html(html);

    // Toggle detalhamento de preço
    $(".pedido-preco-toggle").on("click", function () {
      var $detail = $(this).next(".pedido-preco-detail");
      var $icon = $(this).find("i");
      $detail.slideToggle(200);
      $icon.toggleClass("la-angle-down la-angle-up");
    });
  }

  // =============================================
  // UTILS
  // =============================================
  function renderLoading($el) {
    $el.html(
      '<div class="pers-loading">' +
        '<div class="pers-loading-spinner"></div>' +
        '<span>Carregando...</span>' +
      '</div>'
    );
  }

  function renderErro($el) {
    $el.html('<p style="text-align:center;padding:30px;color:#888;">Erro ao carregar dados. Tente novamente.</p>');
  }

  function escapeHtml(str) {
    if (!str) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  init();
})();
